export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11904.d58155f2.jpg";